<template>
  <div class="login-container">
    <div class="login-left">
      <div class="login-logo">
        <img src="../../assets/login.png" alt="" />
      </div>
    </div>
    <div class="login-right">
      <div class="login-view" v-if="status == 1">
        <div class="login-title">欢迎登录 地址智寻</div>

        <div class="input-window">
          <div class="input-title">账号</div>
          <el-input
            v-model="loginRequest.phoneNumber"
            style="width: 414px; height: 56px"
            placeholder="请输入手机号"
            :prefix-icon="Message"
          />
        </div>

        <div class="input-window">
          <div class="input-title">密码</div>
          <el-input
            v-model="loginRequest.password"
            style="width: 414px; height: 56px"
            show-password
            placeholder="请输入密码"
            :prefix-icon="Lock"
          />
        </div>
        <div class="changeButton" @click="changeStatus">返回注册</div>
        <div class="login-button" @click="login">登录</div>
      </div>

      <div class="login-view" v-if="status == 2">
        <div class="login-title">创建您的组织</div>

        <div class="input-window">
          <div class="input-title">组织名称</div>
          <el-input
            v-model="organizationAddRequest.organizationName"
            style="width: 414px; height: 56px"
            placeholder="请输入组织名称"
            :prefix-icon="Cloudy"
          />
        </div>
        <div class="input-window">
          <div class="input-title">负责人名称</div>
          <el-input
            v-model="organizationAddRequest.memberName"
            style="width: 414px; height: 56px"
            placeholder="请输入负责人名称"
            :prefix-icon="Avatar"
          />
        </div>
        <div class="input-window">
          <div class="input-title">账号</div>
          <el-input
            v-model="organizationAddRequest.phoneNumber"
            style="width: 414px; height: 56px"
            placeholder="请输入手机号"
            :prefix-icon="Message"
          />
        </div>

        <div class="input-window">
          <div class="input-title">密码</div>
          <el-input
            v-model="organizationAddRequest.password"
            style="width: 414px; height: 56px"
            show-password
            placeholder="请输入密码"
            :prefix-icon="Lock"
          />
        </div>
        <div class="changeButton" @click="changeStatus">返回登录</div>
        <div class="login-button" @click="register">注册账号</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "loginView",
};
</script>

<script setup>
import { Lock, Message, Avatar, Cloudy } from "@element-plus/icons-vue";
import { ref, onMounted } from "vue";
import { user } from "../../../api/index";
import { useRouter } from "vue-router";
const router = useRouter();
let loginRequest = ref({
  phoneNumber: "",
  password: "",
});
let organizationAddRequest = ref({
  organizationName: "",
  memberName: "",
  phoneNumber: "",
  password: "",
});
let status = ref(1);
// 登录
function login() {
  user.login(loginRequest.value).then((res) => {
    if (res.code == 200) {
      localStorage.setItem("postal-token", res.data.token);
      router.push({ path: "/" });
    }
  });
}
// 注册
function register() {
  user.register(organizationAddRequest.value).then((res) => {});
}

//切换
function changeStatus() {
  if (status.value === 1) {
    status.value = 2;
  } else if (status.value === 2) {
    status.value = 1;
  }
}
</script>
<style>
.login-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: row;
}
.login-left {
  height: 100%;
  flex: 1;
  display: flex;
}

.login-right {
  display: flex;
  height: 100%;
  flex: 1;
}
.login-logo {
  margin: auto;
  align-items: center;
}
.login-logo img {
  height: 494px;
  width: 631px;
}

.login-view {
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login-title {
  height: 6vh;
  line-height: 6vh;
  font-weight: 400;
  font-size: 24px;
  color: rgba(54, 65, 79, 1);
}
.input-title {
  color: rgba(54, 65, 79, 1);
  font-weight: 500;
}
.input-window {
  margin-bottom: 15px;
}
.input-title {
  margin-bottom: 10px;
}
.login-button {
  color: white;
  width: 414px;
  background-color: rgba(75, 160, 108, 1);
  border-radius: 4px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  cursor: pointer;
}
.changeButton {
  width: 414px;
  text-align: right;
  margin-bottom: 10px;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
</style>
